import { requestPost } from 'utils/request';
import { logError } from '@tcc/scarecrow';

const BASE_URL = '/api/user';

export function recoveryEmailRequest(email) {
  return requestPost(`${BASE_URL}/reset-password-email`, {
    data: JSON.stringify({
      email,
      to: `/static/auth-pages/index.html#/reset_password/create_new_password/${email}/`
    })
  }).then((response) => {
    const requestId = response.headers.get('x-http-request-id');
    if (!response.ok) {
      const message = `Endpoint Error: ${response.status} ${response.statusText}`;
      let extraData = { serviceError: { requestId } };
      logError(message, extraData, true);
      return Promise.reject({
        status: response.status,
        statusText: response.statusText
      });
    }
    return response;
  });
}
